import * as React from 'react';
import './navbar-item.scss';
import { RootState } from 'core/redux/store';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { setExpandedMenuItem, setMenuItem, setSidebar } from 'core/redux/actions';

const mapState = (state: RootState) => ({
    state: state,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    id: number;
    title: string;
    icon?: React.ReactNode;
    link?: string;
    className?: string;
    isActive?: boolean;
    onClickHandle?: () => void;
    childrens?: {
        id: number;
        title: string;
        link: string;
        itemKey?: string;
    }[];
    waitingCounts?: Record<string, number>;
}

const MobileNavigationbarItem: React.FC<Props> = (props) => {
    const dispatch = useDispatch();

    const hasChildren = !!props.childrens?.length;
    const isExpanded = props.state.expandedMenu === props.id;

    const countOf = (itemKey?: string) => (itemKey ? (props.waitingCounts?.[itemKey] ?? 0) : 0);
    const totalWaitingCount = props.childrens?.reduce((sum, child) => sum + countOf(child.itemKey), 0) ?? 0;

    function onSelect() {
        dispatch(setMenuItem(props.id));
        dispatch(setSidebar('close'));
    }

    return (
        <>
            <Link
                // آیتم گروهی لینک ندارد؛ کلیک روی آن فقط زیرمنو را باز/بسته می‌کند.
                // قبلاً همین آیتم‌ها با link خالی رندر می‌شدند و عملاً لینک مرده بودند.
                to={hasChildren ? '' : (props.link ?? '')}
                onClick={() => {
                    if (hasChildren) {
                        dispatch(setExpandedMenuItem(isExpanded ? -1 : props.id));
                        return;
                    }
                    onSelect();
                }}
                className={`mobile-navigationbar-item ${
                    !hasChildren && props.state.menu === props.id ? 'active' : ''
                } ${props.className ?? ''} ${props.isActive ? 'filled' : ''} ${hasChildren ? 'has-children' : ''} ${
                    isExpanded ? 'expanded' : ''
                }`}
            >
                <div className="content">
                    {props.icon}
                    <p className="title">{props.title}</p>
                    {totalWaitingCount > 0 && <span className="waiting-count">{totalWaitingCount}</span>}
                    {/* نشانه‌ی داشتن زیرمنو؛ با باز شدن، ۱۸۰ درجه می‌چرخد. */}
                    {hasChildren && <DownOutlined className="expand-arrow" />}
                </div>
            </Link>
            {hasChildren && isExpanded && (
                <ul className="mobile-navigationbar-subitems">
                    {props.childrens?.map((child) => {
                        const waitingCount = countOf(child.itemKey);
                        return (
                            <Link key={child.id} to={child.link}>
                                <li
                                    className={`${props.state.menu === child.id ? 'active' : ''}`}
                                    onClick={() => {
                                        dispatch(setMenuItem(child.id));
                                        dispatch(setSidebar('close'));
                                    }}
                                >
                                    {child.title}
                                    {waitingCount > 0 && <span className="waiting-count">{waitingCount}</span>}
                                </li>
                            </Link>
                        );
                    })}
                </ul>
            )}
        </>
    );
};
export default connector(MobileNavigationbarItem);
